export function routes($stateProvider) {
    $stateProvider
        .state('app.elv.elevadores', {
        url: '/elevadores',
        abstract: true,
        template: '<div ui-view></div>'
    })
        .state('app.elv.elevadores.list', {
        url: '/',
        title: 'Gestão de Elevadores',
        template: require('./directory/directory.view.html'),
        controller: 'DirectoryElevadorController',
        controllerAs: 'vm',
        params: {
            state: {
                value: 1,
                dynamic: true
            },
            page: {
                value: 1,
                dynamic: true
            },
            items: {
                value: 20,
                dynamic: true
            },
            order: {
                value: "id",
                dynamic: true
            },
            sort: {
                value: "desc",
                dynamic: true
            },
            filter: {
                dynamic: true
            }
        },
        role: 'elvListarElevadores'
    })
        .state('app.elv.elevadores.details', {
        url: '/{id}',
        title: 'Detalhes do Elevador',
        template: require('./details/details.view.html'),
        controller: 'DetalhesElevadorController',
        controllerAs: 'vm',
        role: 'elvListarElevadores'
    });
}
routes.$inject = ['$stateProvider'];
